<template>
  <div style="margin: 10px 10px 0 10px;">
    <el-tabs v-model="tabName" type="card" @tab-click="handleClick">
      <el-tab-pane name="application">
        <div slot="label" style="width: 70px;text-align: center;">我的申请</div>
        <application ref="application" :end-count="wInfo.ToEndCount" />
      </el-tab-pane>
      <el-tab-pane name="tocheck">
        <template slot="label">
          <el-badge :value="wInfo.ToDoCount" :hidden="wInfo.ToDoCount==0" class="my-badge">
            <div style="width: 70px;text-align: center;">我的待办</div>
          </el-badge>
        </template>
        <tocheck ref="tocheck" />
      </el-tab-pane>
      <el-tab-pane name="todo">
        <template slot="label">
          <el-badge :value="wInfo.ToReadCount" :hidden="wInfo.ToReadCount==0" class="my-badge">
            <div style="width: 70px;text-align: center;">我的待阅</div>
          </el-badge>
        </template>
        <todo ref="todo" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import application from "@/components/wf/work/application/index";
import tocheck from "@/components/wf/work/tocheck/index";
import todo from "@/components/wf/work/todo/index";
export default {
  name: "work",
  components: {
    application,
    tocheck,
    todo,
  },
  data() {
    return {
      work_api: require("@/api/wf/work").default,
      instance_api: require("@/api/wf/instance").default,
      tabName: "application",
    };
  },
  computed: {
    wInfo() {
      return this.$store.state.user.workinfo;
    },
  },
  mounted() {
    //localhost:81/#/wf/work?type=1&workid=55
    //localhost:81/#/wf/work?type=0&instanceId=2
    // console.log("route", this.$route);
    var query = this.$route.query;
    if (query.type == "1") this.tabName = "tocheck";
    if (query.type == "2") this.tabName = "todo";
    if (query.workid) {
      this.work_api.getMyWorkWithFormList({ id: query.workid }).then((res) => {
        // console.log("res", res);
        var data = res.Data[0];
        this.$refs[this.tabName].todo(data);
        this.$router.replace({ query: {} });
        this.reload();
      });
    } else if (query.instanceId) {
      this.instance_api
        .getMyInstanceWithFormList({ id: query.instanceId })
        .then((res) => {
          // console.log("res", res);
          var data = res.Data[0];
          this.$refs[this.tabName].details(data);
          this.$router.replace({ query: {} });
          this.reload();
        });
    } else {
      this.reload();
    }
  },
  methods: {
    handleClick(e) {
      this.reload();
    },
    reload() {
      this.$refs[this.tabName].getData();
    },
  },
};
</script>
<style lang="scss" >
.my-badge {
  margin-top: -4px;
  .el-badge__content {
    top: 9px;
    right: 8px;
    z-index: 1;
    line-height: 16px;
  }
}
</style>